module.exports = __webpack_public_path__ + "img/3f_r_excel.ce43de8f.jpg";